import type { ReactNode } from "react";
import { tokens } from "@core/theme/tokens";

/**
 * Cabecera fija del cuerpo de un `SidePanel` (rótulo pequeño + título grande
 * + contenido opcional debajo, como badges o un botón de acción): mismo
 * bloque en `ProgressDetailSheet` (Gran Premio) y `HttpRequestLogScreen`
 * (detalle de la traza HTTP) — solo cambian el rótulo, el tamaño/interlineado
 * del título y lo que va debajo (jscpd, revisión de duplicación 2026-09-23).
 */
export function SidePanelHeader({
  label,
  title,
  titleFontSize = 22,
  titleLineHeight = 1.15,
  children,
}: {
  label: string;
  title: ReactNode;
  titleFontSize?: number;
  titleLineHeight?: number;
  children?: ReactNode;
}) {
  return (
    <div
      style={{
        padding: "22px 26px",
        borderBottom: `1px solid ${tokens.surface.line}`,
      }}
    >
      <div
        className="label"
        style={{ marginBottom: 6, color: tokens.text.tertiary }}
      >
        {label}
      </div>
      <h2
        className="display"
        style={{
          fontSize: titleFontSize,
          margin: 0,
          lineHeight: titleLineHeight,
        }}
      >
        {title}
      </h2>
      {children}
    </div>
  );
}
